import React from 'react';
import { useTranslation } from 'react-i18next';
import RSVPForm from '@/components/rsvp/RSVPForm';

export const Rsvp: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div 
            className="min-h-screen py-16 md:py-24 animate-fade-in relative z-10 flex items-center justify-center px-4"
            style={{ backgroundImage: "url('/images/background.svg')", backgroundSize: 'cover', backgroundAttachment: 'fixed', backgroundPosition: 'center' }}
        >
            <div className="bg-white max-w-2xl w-full mx-auto p-8 md:p-16 relative">
                <div className="text-center mb-16 space-y-4">
                    <h1 className="text-4xl md:text-5xl lg:text-5xl font-display text-[#bf9c56] tracking-[0.3em] uppercase ml-4">
                        {/* Adding ml-4 to offset the tracking space visually centering */}
                        {t('rsvp.title')}
                    </h1>
                    <p className="text-[#3c2312] font-sans text-sm md:text-base tracking-[0.1em] mx-auto max-w-[80%] opacity-80">
                        {t('rsvp.deadline')}
                    </p>
                </div>

                <RSVPForm />
            </div>
        </div>
    );
};
